export default {
  namespaced: true,
  state: {
    creditCardPaymentInfo: {
      paymentModeCode: "creditcard",
      amount: 0,
      code: "creditcard",
      cardCompanyCode: "C04",
      installmentPlan: 0,
      cardNumber: "",
      validToYear: "",
      validToMonth: "",
      cardAuthNumber: "",
      cardPassword: ""
    },
  },
  mutations: {
    reset(state) {
      state.creditCardPaymentInfo = {
        paymentModeCode: "creditcard",
          amount: 0,
          code: "creditcard",
          cardCompanyCode: "C04",
          installmentPlan: 0,
          cardNumber: "",
          validToYear: "",
          validToMonth: "",
          cardAuthNumber: "",
          cardPassword: ""
      }
    },
    creditCardAmount(state, value = 0) {
      state.creditCardPaymentInfo.amount = value;
    },
    creditCardCompanyCode(state, value = "") {
      state.creditCardPaymentInfo.cardCompanyCode = value;
    },
    installmentPlan(state, value = 0) {
      state.creditCardPaymentInfo.installmentPlan = value;
    },
    cardNumber(state, value = "") {
      state.creditCardPaymentInfo.cardNumber = value;
    },
    validYear(state, value = "") {
      state.creditCardPaymentInfo.validToYear = value;
    },
    validMonth(state, value = "") {
      state.creditCardPaymentInfo.validToMonth = value;
    },
    cardAuth(state, value = "") {
      state.creditCardPaymentInfo.cardAuthNumber = value;
    },
    cardPassword(state, value = "") {
      state.creditCardPaymentInfo.cardPassword = value;
    }
  },
  getters: {
    creditCardPaymentInfo(state) {
      return state.creditCardPaymentInfo;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/creditcard.js